import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface FecImportMappingTableScrollAreaProps {
  children: ReactNode
}

export const FecImportMappingTableScrollArea = ({ children }: FecImportMappingTableScrollAreaProps): ReactElement => (
  <Styled.FecImportMappingTableScrollAreaWrapper>{children}</Styled.FecImportMappingTableScrollAreaWrapper>
)
